import { render } from "./QuestionFourScreen.vue?vue&type=template&id=3ebe3fe2&scoped=true&lang=html"
import script from "./QuestionFourScreen.vue?vue&type=script&lang=js"
export * from "./QuestionFourScreen.vue?vue&type=script&lang=js"

import "./QuestionFourScreen.vue?vue&type=style&index=0&id=3ebe3fe2&lang=scss&scoped=true"

import exportComponent from "/Users/peterdevos/Apps/clawmachine_topdesk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ebe3fe2"]])

export default __exports__